export default __webpack_public_path__ + "static/einmalig-hybrid-national-ca01ec610db2434caccd11fb3eb451c4.jpg";